<tec-modal
	[isVisible]="showModal"
	[title]="'PROCESSES.CREATE_MODAL.TITLE' | translate"
    [buttonPrimaryLabel]="showStepConfig && !steps.at(1)?.selected ? ('PROCESSES.CREATE_MODAL.GENERATE_LINK' | translate) : ''"
    [buttonSecondaryLabel]="link && !loadingModal && (showStepConfig && !steps.at(0)?.selected) || !showStepConfig ? ('PROCESSES.CREATE_MODAL.GENERATE_OTHER_LINK' | translate) : ''"
	(closeEvent)="closeModal($event)">
	<ng-container body [formGroup]="form">
        @if (showStepConfig) {
            <tec-stepper-micro [steps]="steps" (clickEvent)="clickStep($event)"></tec-stepper-micro>
            @if (alertError) {
                <tec-alert [msg]="alertError" hiddenCloseButton></tec-alert>
            }
            @if (steps.length && steps.at(0)?.selected) {
                <div class="grid grid-i2">
                    @if (!workflow) {
                        @if (masterService.companies.length > 1 || rolePermissions.isSuperadmin()) {
                            <tec-form-group
                                [label]="'PROCESSES.CREATE_MODAL.COMPANY' | translate"
                                [errorMsg]="reactiveFormService.hasMsgError(form.get('company'))"
                            >
                                <tec-select
                                    search
                                    allowDeselect
                                    formControlName="company"
                                    [options]="companies"
                                    [placeholder]="'PROCESSES.CREATE_MODAL.COMPANY_PLACEHOLDER' | translate"
                                    [hasError]="reactiveFormService.hasError(form.get('company'))"
                                    (valueChange)="updateOptionsByCompany()"
                                />
                            </tec-form-group>
                        }
                        <tec-form-group
                            [label]="'PROCESSES.CREATE_MODAL.WORKFLOW' | translate"
                            [errorMsg]="reactiveFormService.hasMsgError(form.get('workflow'))">
                            <tec-select
                                search
                                formControlName="workflow"
                                [options]="workflows"
                                [hasError]="reactiveFormService.hasError(form.get('workflow'))"
                                [placeholder]="'PROCESSES.CREATE_MODAL.WORKFLOW_PLACEHOLDER' | translate"
                            />
                        </tec-form-group>
                    }
                    <tec-form-group
                        [label]="'PROCESSES.CREATE_MODAL.EXPIRATION' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('expiration'))">
                        <tec-select
                            formControlName="expiration"
                            [options]="expirationOptions"
                            [hasError]="reactiveFormService.hasError(form.get('expiration'))"
                            [placeholder]="'PROCESSES.CREATE_MODAL.EXPIRATION_PLACEHOLDER' | translate"
                        />
                    </tec-form-group>
                    @if (shouldShowPhoneField()) {
                        <tec-form-group
                            [label]="'PROCESSES.CREATE_MODAL.PHONE' | translate"
                            [errorMsg]="reactiveFormService.hasMsgError(form.get('phone'))">
                            <app-phone-input
                                formControlName="phone"
                                [hasError]="reactiveFormService.hasError(form.get('phone'))"
                            />
                        </tec-form-group>
                    }
                </div>
                @if (isWorkflowTwoFactorEnabled()) {
                    <tec-alert
                        status="warning"
                        [msg]="'PROCESSES.CREATE_MODAL.AUTH_CHANNEL_NOTICE' | translate"
                        hiddenCloseButton
                    ></tec-alert>
                }
                @if (showConfiguredForm) {
                    <tec-tile [title]="'PROCESSES.CREATE_MODAL.FORMS_TITLE' | translate" [formGroup]="formConfig">
                        <div class="grid grid-i2">
                            @for (control of formConfigControls; track control.name) {
                                <tec-form-group
                                    [label]="getLabelControl(control.name)"
                                    [errorMsg]="reactiveFormService.hasMsgError(formConfig.get(control.name))">
                                    @switch (control.type) {
                                        @case ('date') {
                                            <tec-datepicker
                                                [formControlName]="control.name"
                                                [hasError]="reactiveFormService.hasError(formConfig.get(control.name))"
                                                type="input"
                                            />
                                        }
                                        @case ('select') {
                                            <tec-select
                                                [formControlName]="control.name"
                                                [options]="getSelectOptions(control.name)"
                                                [search]="selectControlSupportsSearch(control.name)"
                                                [hasError]="reactiveFormService.hasError(formConfig.get(control.name))"
                                                [placeholder]="getLabelControl(control.name)"
                                            />
                                        }
                                        @default {
                                            <tec-input
                                                [formControlName]="control.name"
                                                [hasError]="reactiveFormService.hasError(formConfig.get(control.name))"
                                            />
                                        }
                                    }
                                </tec-form-group>
                            }
                        </div>
                    </tec-tile>
                }
            }
            @if (steps.length && steps.at(1)?.selected) {
                @if (loadingModal) {
                    <tec-tile [title]="loadingModal" [type]="'loading'"></tec-tile>
                } @else if (link) {
                    <div class="link_section">
                        <tec-tile [title]="workflow ? workflow.label : ''" [icon]="workflow ? 'icon-flow' : undefined">
                            <tec-info-group [label]="'PROCESSES.CREATE_MODAL.LINK' | translate">
                                <tec-copy-text
                                    [label]="link"
                                    [labelToCopy]="link"
                                ></tec-copy-text>
                            </tec-info-group>
                            <tec-form-group
                                [label]="'PROCESSES.CREATE_MODAL.SEND_EMAIL' | translate"
                                [errorMsg]="reactiveFormService.hasMsgError(formEmail)">
                                <tec-input
                                    [formControl]="formEmail"
                                    [hasError]="reactiveFormService.hasError(formEmail)"
                                    [placeholder]="'correo@correo.com'"
                                />
                                <tec-button [label]="'BUTTON.SEND' | translate" (clickEvent)="sendLinkToEmail()"></tec-button>
                            </tec-form-group>
                            <tec-form-group
                                [label]="'PROCESSES.CREATE_MODAL.SEND_SMS' | translate"
                                [errorMsg]="reactiveFormService.hasMsgError(formPhoneShare)">
                                <app-phone-input
                                    [formControl]="formPhoneShare"
                                    [hasError]="reactiveFormService.hasError(formPhoneShare)"
                                />
                                <tec-button [label]="'BUTTON.SEND' | translate" (clickEvent)="sendLinkToSms()"></tec-button>
                            </tec-form-group>
                            <tec-form-group
                                [label]="'PROCESSES.CREATE_MODAL.SEND_WHATSAPP' | translate"
                                [errorMsg]="reactiveFormService.hasMsgError(formPhoneWhatsapp)">
                                <app-phone-input
                                    [formControl]="formPhoneWhatsapp"
                                    [hasError]="reactiveFormService.hasError(formPhoneWhatsapp)"
                                />
                                <tec-button [label]="'BUTTON.SEND' | translate" (clickEvent)="sendLinkToWhatsapp()"></tec-button>
                            </tec-form-group>
                        </tec-tile>
                        <tec-tile class="tile-qr">
                            <tec-qr [url]="link" [showLinks]="false"/>
                            <tec-link [label]="'PROCESSES.CREATE_MODAL.DOWNLOAD_QR' | translate"
                                [size]="'sm'"
                                style="align-self: center;"
                                (click)="downloadQr()">
                                <tec-icon name="icon-download" size="xs"></tec-icon>
                            </tec-link>
                        </tec-tile>
                    </div>
                } @else {
                    <tec-empty-state
                        [title]="'GENERAL.NO_LINK' | translate"
                        [size]="'default'"
                        [type]="'empty'"
                        [labelAction]="'PROCESSES.CREATE_MODAL.GENERATE_LINK' | translate"
                        (clickEvent)="generateUrl()"
                    ></tec-empty-state>
                }
            }
        } @else {
            <span>{{ 'PROCESSES.CREATE_MODAL.DESCRIPTION' | translate }}</span>
            <ng-container>
                @if (alertError) {
                    <tec-alert [msg]="alertError" hiddenCloseButton></tec-alert>
                }
                <div class="grid grid-i2">
                    @if (!workflow) {
                        <tec-form-group
                            [label]="'PROCESSES.CREATE_MODAL.WORKFLOW' | translate"
                            [errorMsg]="reactiveFormService.hasMsgError(form.get('workflow'))">
                            <tec-select
                                search
                                formControlName="workflow"
                                [options]="workflows"
                                [hasError]="reactiveFormService.hasError(form.get('workflow'))"
                                [placeholder]="'PROCESSES.CREATE_MODAL.WORKFLOW_PLACEHOLDER' | translate"
                            />
                        </tec-form-group>
                    }
                    <tec-form-group
                        [label]="'PROCESSES.CREATE_MODAL.EXPIRATION' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('expiration'))">
                        <tec-select
                            formControlName="expiration"
                            [options]="expirationOptions"
                            [hasError]="reactiveFormService.hasError(form.get('expiration'))"
                            [placeholder]="'PROCESSES.CREATE_MODAL.EXPIRATION_PLACEHOLDER' | translate"
                        />
                    </tec-form-group>
                    @if (shouldShowPhoneField()) {
                        <tec-form-group
                            [label]="'PROCESSES.CREATE_MODAL.PHONE' | translate"
                            [errorMsg]="reactiveFormService.hasMsgError(form.get('phone'))">
                            <app-phone-input
                                formControlName="phone"
                                [hasError]="reactiveFormService.hasError(form.get('phone'))"
                            />
                        </tec-form-group>
                    }
                </div>
                @if (isWorkflowTwoFactorEnabled()) {
                    <tec-alert
                        status="warning"
                        [msg]="'PROCESSES.CREATE_MODAL.AUTH_CHANNEL_NOTICE' | translate"
                        hiddenCloseButton
                    ></tec-alert>
                }
                @if (loadingModal) {
                    <tec-tile [title]="loadingModal" [type]="'loading'"></tec-tile>
                } @else if (link) {
                    <div class="link_section">
                        <tec-tile [title]="workflow ? workflow.label : ''" [icon]="workflow ? 'icon-flow' : undefined">
                            <tec-info-group [label]="'PROCESSES.CREATE_MODAL.LINK' | translate">
                                <tec-copy-text
                                    [label]="link"
                                    [labelToCopy]="link"
                                ></tec-copy-text>
                            </tec-info-group>
                            <tec-form-group
                                [label]="'PROCESSES.CREATE_MODAL.SEND_EMAIL' | translate"
                                [errorMsg]="reactiveFormService.hasMsgError(formEmail)">
                                <tec-input
                                    [formControl]="formEmail"
                                    [hasError]="reactiveFormService.hasError(formEmail)"
                                    [placeholder]="'correo@correo.com'"
                                />
                                <tec-button [label]="'BUTTON.SEND' | translate" (clickEvent)="sendLinkToEmail()"></tec-button>
                            </tec-form-group>
                            <tec-form-group
                                [label]="'PROCESSES.CREATE_MODAL.SEND_SMS' | translate"
                                [errorMsg]="reactiveFormService.hasMsgError(formPhoneShare)">
                                <app-phone-input
                                    [formControl]="formPhoneShare"
                                    [hasError]="reactiveFormService.hasError(formPhoneShare)"
                                />
                                <tec-button [label]="'BUTTON.SEND' | translate" (clickEvent)="sendLinkToSms()"></tec-button>
                            </tec-form-group>
                            <tec-form-group
                                [label]="'PROCESSES.CREATE_MODAL.SEND_WHATSAPP' | translate"
                                [errorMsg]="reactiveFormService.hasMsgError(formPhoneWhatsapp)">
                                <app-phone-input
                                    [formControl]="formPhoneWhatsapp"
                                    [hasError]="reactiveFormService.hasError(formPhoneWhatsapp)"
                                />
                                <tec-button [label]="'BUTTON.SEND' | translate" (clickEvent)="sendLinkToWhatsapp()"></tec-button>
                            </tec-form-group>
                        </tec-tile>
                        <tec-tile class="tile-qr">
                            <tec-qr [url]="link" [showLinks]="false"/>
                            <tec-link [label]="'PROCESSES.CREATE_MODAL.DOWNLOAD_QR' | translate"
                                [size]="'sm'"
                                style="align-self: center;"
                                (click)="downloadQr()">
                                <tec-icon name="icon-download" size="xs"></tec-icon>
                            </tec-link>
                        </tec-tile>
                    </div>
                }
            </ng-container>
        }
    </ng-container>
</tec-modal>
